import { render, staticRenderFns } from "./CardKomchat.vue?vue&type=template&id=063a4f01&scoped=true&"
import script from "./CardKomchat.vue?vue&type=script&lang=js&"
export * from "./CardKomchat.vue?vue&type=script&lang=js&"
import style0 from "./CardKomchat.vue?vue&type=style&index=0&id=063a4f01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063a4f01",
  null
  
)

export default component.exports